import { Component } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import shallowCompare from 'react-addons-shallow-compare';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIButton from 'UIComponents/button/UIButton';
import EditFormControl from 'ContentComponents/cmv2/EditFormControl';
import Small from 'UIComponents/elements/Small';
import ImagePreview from 'ContentComponents/cmv2/fields/ImagePreview';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.cta.${key}`;
const buttonI18nKey = suffix => `ContentComponents.buttons.${suffix}`;
class CtaBase extends Component {
  constructor(props) {
    super(props);
    this.onEdit = this.onEdit.bind(this);
    this.onDelete = this.onDelete.bind(this);
  }
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }
  onEdit() {
    const {
      onOpenEditor = emptyFunction
    } = this.props;
    onOpenEditor();
  }
  onDelete() {
    const {
      onFieldChange = emptyFunction
    } = this.props;
    onFieldChange('');
  }
  renderImage() {
    const {
      hasCtaAccess = false,
      selectedCtaImage
    } = this.props;
    const {
      altText,
      url
    } = selectedCtaImage || {};
    if (!selectedCtaImage) {
      // This should be removed once the CTA fetch works without the cta-access scope
      // Context: https://hubspot.slack.com/archives/C01JTBPB7DL/p1617030584007700
      const zeroStateKey = hasCtaAccess ? i18nKey('noCtaSelected') : i18nKey('noAccess');
      return /*#__PURE__*/_jsx("span", {
        className: "cmv2-cta-zero-state",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: zeroStateKey
        })
      });
    }
    return /*#__PURE__*/_jsx(ImagePreview, {
      alt: altText,
      src: url
    });
  }
  renderReplaceButton() {
    const {
      hasCtaAccess = false,
      onOpenPicker = emptyFunction,
      readOnly = false,
      value = null
    } = this.props;
    const isDisabled = !value || readOnly || !hasCtaAccess;
    if (!value) {
      return null;
    }
    return /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "cmv2-cta-replace-button",
      disabled: isDisabled,
      onClick: onOpenPicker,
      use: "link",
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: buttonI18nKey('replace')
        })
      })
    });
  }
  renderAddButton() {
    const {
      hasCtaAccess = false,
      onOpenPicker = emptyFunction,
      readOnly = false,
      value = null
    } = this.props;
    const isDisabled = readOnly || !hasCtaAccess;
    if (value) {
      return null;
    }
    return /*#__PURE__*/_jsx(UIButton, {
      className: "m-top-3",
      "data-test-id": "cmv2-cta-add-button",
      disabled: isDisabled,
      onClick: onOpenPicker,
      size: "small",
      use: "tertiary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey('insertCta')
      })
    });
  }
  renderRemoveButton(disableOnMissing = false) {
    const {
      hasCtaAccess = false,
      readOnly = false,
      required,
      value = null
    } = this.props;
    const isDisabled = readOnly || Boolean(required && value && hasCtaAccess);
    if (!disableOnMissing && !value) {
      return null;
    }
    return /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "cmv2-cta-remove-button",
      disabled: isDisabled,
      onClick: this.onDelete,
      use: "link",
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: buttonI18nKey('remove')
        })
      })
    });
  }
  renderEditButton(disableOnMissing = false) {
    const {
      disableEdit = false,
      editTooltip,
      hasCtaAccess = false,
      readOnly = false,
      value = null
    } = this.props;
    const isDisabled = readOnly || !value || disableEdit || !hasCtaAccess;
    if (!disableOnMissing && !value) {
      return null;
    }
    let editButton = /*#__PURE__*/_jsx(UIButton, {
      className: "cmv2-cta-edit-button",
      "data-test-id": "cmv2-cta-edit-button",
      disabled: isDisabled,
      onClick: this.onEdit,
      size: "small",
      use: "tertiary-light",
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('editCta')
        })
      })
    });
    if (editTooltip) {
      editButton = /*#__PURE__*/_jsx(UITooltip, {
        title: editTooltip,
        children: editButton
      });
    }
    return editButton;
  }
  render() {
    const {
      label = '',
      help_text: helpText,
      inline_help_text: inlineHelpText,
      required,
      value = null
    } = this.props;
    return /*#__PURE__*/_jsx(EditFormControl, {
      helpText: helpText,
      inlineHelpText: inlineHelpText,
      label: label,
      labelItemRight: /*#__PURE__*/_jsxs("div", {
        children: [this.renderReplaceButton(), this.renderRemoveButton()]
      }),
      required: required,
      children: /*#__PURE__*/_jsxs("div", {
        children: [this.renderImage(), value ? this.renderEditButton() : this.renderAddButton()]
      })
    });
  }
}
export default CtaBase;